import { ThemeColor, ThemeTonalRange } from '@philips-emr/tws-constants';
import { FileService } from '@philips-emr/tws-core/lib/services';
import DefaultFileHandler from '@philips-emr/tws-core/lib/services/file/default-file-handler';
import FileHandlerConfiguration from '@philips-emr/tws-core/lib/services/file/file-handler-configuration';

import { Endpoints } from '../definitions/endpoints';

export interface Wsuite {
  dsColorRange?: ThemeColor;
  dsUrlLogoFooter?: string;
  dsLinkFacebook?: string;
  dsLinkInstagram?: string;
  dsLinkLinkedin?: string;
  dsLinkTwitter?: string;
  dsLinkYoutube?: string;
  dsEndereco?: string;
  nrFoneContato?: string;
  dsEmailRodape?: string;
  dsUrlLogoHeaderLogin?: string;
  dsAccentColor?: ThemeColor;
  dsNavTonalRange?: ThemeTonalRange;
  dsLoginTonalRange?: ThemeTonalRange;
}

class Configuration {

  private static data: Promise<Wsuite>;

  static getData(): Promise<Wsuite> {
    return this.data;
  }

  static init(wsuite: Promise<Wsuite>): void {
    this.data = wsuite;

    const config = new FileHandlerConfiguration();
    config.uploadUrl = Endpoints.POST.UPLOAD_FILE;
    config.previewUrl = Endpoints.GET.PREVIEW_FILE;
    config.removeUrl = Endpoints.DELETE.REMOVE_FILE;

    const handler = new DefaultFileHandler();
    handler.setConfiguration(config);

    FileService.setFileHandler(handler);
  }
}

export {
  Configuration,
};
